(() => {
  if (window.dpDeliveryInit) return
  window.dpDeliveryInit = true

  let cart
  let timer
  let requestVersion = 0
  let writeTotal = null
  const noteWrite = data => { if (Number.isFinite(data?.total_price)) writeTotal = data.total_price }
  const root = window.Shopify?.routes?.root || '/'
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency', currency: 'GBP'
  }).format(value / 100)
  const copy = element => JSON.parse(element.dataset.dpCopy)
  const text = (template, amount) => template.replace('[amount]', money(amount))
  const ids = element => element.dataset.letterboxVariants.split(',').filter(Boolean)
  const assetBase = (document.currentScript?.src || '').replace(/displaypro-delivery\.js.*$/, '')

  function subtotal(box, fallback) {
    const form = box.closest('form')
    const totals = form?.querySelectorAll('.hulkapps-cart-total') || []
    let total = fallback
    for (const element of totals) {
      if (element.hidden || getComputedStyle(element).display === 'none') continue
      const value = element.textContent.trim().replace(/[^0-9.,]/g, '').replaceAll(',', '')
      if (!/^\d+(\.\d{1,2})?$/.test(value)) continue
      const amount = Math.round(Number(value) * 100)
      if (Number.isFinite(amount) && amount >= 0 && amount <= fallback) total = Math.min(total, amount)
    }
    return total
  }

  // Displaypro 21 Oct 2026: after a shopper has visited checkout, Shopify's cart
  // change/update responses can include the chosen delivery charge in total_price,
  // and Hulk copies that into the basket "Subtotal". Keep the subtotal to goods only
  // (from cart.js items_subtotal_price). If the delivery amount is known from the
  // last cart write, subtract it so a Hulk tier discount still shows; otherwise cap
  // at goods. Rollback: republish theme 155176271941.
  function fixSubtotal(state) {
    const goods = Number.isFinite(state?.items_subtotal_price) ? state.items_subtotal_price : state?.original_total_price
    if (!Number.isFinite(goods) || !state.item_count) return
    const extra = Number.isFinite(writeTotal) && Number.isFinite(state.total_price) ? writeTotal - state.total_price : 0
    document.querySelectorAll('[data-hulkapps-cart-total], .hulkapps-cart-total').forEach(element => {
      const target = element.querySelector('.tax-selector-currency') || element
      const raw = target.textContent.trim()
      if (element.dataset.dpFixed === raw) return
      if (!/^£\s?\d{1,3}(,\d{3})*\.\d{2}$/.test(raw) && !/^£\s?\d+\.\d{2}$/.test(raw)) return
      const amount = Math.round(Number(raw.replace(/[^0-9.]/g, '')) * 100)
      if (!Number.isFinite(amount) || amount <= goods) return
      const corrected = extra > 0 && amount - extra >= 0 && amount - extra <= goods ? amount - extra : goods
      target.textContent = money(corrected)
      element.dataset.dpFixed = target.textContent.trim()
    })
  }

  // Displaypro 22 Oct 2026 (task SEO-8): straight after a calculator (ITORIS D#) size is
  // added, Shopify's first page render doesn't yet know the new variant, so the basket
  // line shows £0.00 and no photo. Fill both from cart.js (the live basket) when the
  // shown price is zero for an item that isn't free. Hulk discount display is untouched.
  function fixLines(state) {
    if (!state?.items?.length) return
    for (const item of state.items) {
      if (!(item.final_price > 0)) continue
      const row = [...document.querySelectorAll('[data-hulkapps-lineitem][data-key]')].find(element => element.dataset.key === item.key)
      if (!row) continue
      const prices = [...row.querySelectorAll('[data-hulkapps-ci-price]')]
      const zero = prices.length > 0 && prices.every(element => {
        const digits = element.textContent.replace(/[^0-9]/g, '')
        return digits !== '' && Number(digits) === 0
      })
      if (zero) {
        const price = item.original_price > item.final_price ? item.original_price : item.final_price
        prices.forEach((element, index) => {
          const amount = prices.length > 1 && index === 0 ? price : item.final_price
          const span = document.createElement('span')
          span.className = 'tax-selector-currency'
          span.textContent = money(amount)
          element.replaceChildren(span)
        })
      }
      const box = row.querySelector('.cart__image')
      if (box && item.image && !box.querySelector('img')) {
        const link = document.createElement('a')
        link.className = 'image-wrap'
        link.href = item.url || '#'
        const img = document.createElement('img')
        img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=360'
        img.alt = item.product_title || ''
        img.loading = 'lazy'
        link.append(img)
        box.replaceChildren(link)
      }
    }
  }

  function render(state) {
    cart = state
    fixSubtotal(state)
    fixLines(state)
    orderLines()
    document.querySelectorAll('[data-dp-delivery]').forEach(box => {
      box.hidden = !state.item_count
      if (!state.item_count) return
      const labels = copy(box)
      const letterboxIds = ids(box)
      const shippingItems = state.items.filter(item => item.requires_shipping !== false)
      const allLetterbox = shippingItems.length > 0 && shippingItems.every(item => letterboxIds.includes(String(item.variant_id)))
      const hasLetterbox = shippingItems.some(item => letterboxIds.includes(String(item.variant_id)))
      const threshold = allLetterbox ? Number(box.dataset.letterboxFreeFrom) : Number(box.dataset.freeFrom)
      const total = subtotal(box, state.total_price)
      const remaining = Math.max(0, threshold - total)
      const percent = Math.min(100, Math.max(0, Math.floor(total * 100 / threshold)))
      const estimate = total >= threshold ? 0 : allLetterbox ? Number(box.dataset.letterboxRate) : total >= Number(box.dataset.band2From) ? Number(box.dataset.rate2) : Number(box.dataset.rate1)
      box.querySelector('[data-dp-msg]').textContent = !shippingItems.length ? labels.no_shipping : remaining ? text(labels.remaining, remaining) : labels.free
      box.querySelector('[data-dp-fill]').style.width = `${percent}%`
      box.querySelector('[data-dp-bar]').setAttribute('aria-valuenow', percent)
      box.querySelector('[data-dp-bar]').hidden = !shippingItems.length
      box.querySelector('[data-dp-est]').textContent = !shippingItems.length ? labels.no_shipping : hasLetterbox && !allLetterbox && total < Number(box.dataset.band2From) ? labels.checkout : text(labels.estimate, estimate)
      if (estimate === 0 && shippingItems.length) box.querySelector('[data-dp-est]').textContent = labels.free_estimate
      box.querySelector('[data-dp-small]').hidden = total >= Number(box.dataset.band2From) || allLetterbox || !shippingItems.length
    })
  }

  function refresh() {
    clearTimeout(timer)
    const version = ++requestVersion
    timer = setTimeout(async () => {
      try {
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' })
        if (!response.ok) throw new Error('cart')
        const state = await response.json()
        if (version === requestVersion) render(state)
      } catch {
        if (version !== requestVersion) return
        document.querySelectorAll('[data-dp-delivery]').forEach(box => {
          const labels = copy(box)
          box.querySelector('[data-dp-msg]').textContent = labels.checkout
          box.querySelector('[data-dp-est]').textContent = ''
          box.querySelector('[data-dp-bar]').hidden = true
        })
      }
    }, 250)
  }

  // Displaypro 21 Oct 2026 (task C5): on cut-to-size calculator pages, once a size is
  // entered, show what this item plus the current basket costs with UK mainland
  // standard delivery. Rates come from the snippet (same bands as checkout).
  function orderLines() {
    document.querySelectorAll('[data-dp-order]').forEach(order => {
      const line = order.closest('[data-dp-product-line]')
      const scope = line.closest('form, .product, main') || document
      const calculator = scope.querySelector('.dpo-container') || document.querySelector('.dpo-container')
      const priceEl = document.querySelector('block-price.product__price')
      const sized = calculator && [...calculator.querySelectorAll('input[type=text], input[type=number]')].some(input => input.name !== 'qty' && input.value.trim())
      const unit = priceEl ? Math.round(Number(priceEl.textContent.replace(/[^0-9.]/g, '')) * 100) : NaN
      if (!sized || !Number.isFinite(unit) || unit <= 0 || !cart) { order.hidden = true; return }
      const labels = copy(line)
      const qty = Math.max(1, parseInt(document.querySelector('input[name="quantity"]')?.value, 10) || 1)
      const basket = cart.item_count ? cart.total_price : 0
      const goods = basket + unit * qty
      const free = Number(line.dataset.freeFrom)
      const rate = goods >= free ? 0 : goods >= Number(line.dataset.band2From) ? Number(line.dataset.rate2) : Number(line.dataset.rate1)
      const template = basket ? labels.order_basket : labels.order
      order.textContent = template.replace('[goods]', money(goods)).replace('[rate]', rate ? money(rate) : 'FREE').replace('[total]', money(goods + rate)).replace('[remaining]', money(Math.max(0, free - goods)))
      if (!rate) order.textContent = labels.order_free.replace('[goods]', money(goods))
      order.hidden = false
    })
  }

  // Displaypro 22 Oct 2026 (task SEO-9): the ITORIS calculator's guide images still point
  // at a deleted theme (t/34), so they show as broken. Swap the known ones for the theme's
  // own dp-opt-*.svg drawings and hide any other broken calculator image.
  const dpoImages = ['height-width-example', 'corner-radii-example', 'corner-chamfer-example',
    'corner-radius-top-left-small', 'corner-radius-top-right-small', 'corner-radius-bottom-left-small', 'corner-radius-bottom-right-small',
    'corner-chamfer-top-left-small', 'corner-chamfer-top-right-small', 'corner-chamfer-bottom-left-small', 'corner-chamfer-bottom-right-small']
  function fixCalculatorImages(scope = document) {
    if (!assetBase) return
    scope.querySelectorAll?.('.dpo-container img, img[src*="dpo_custom_option_"]').forEach(img => {
      if (img.dataset.dpImg) return
      const match = /\/assets\/dpo_custom_option_\d+_([a-z0-9-]+)\.(gif|png|jpe?g)/i.exec(img.getAttribute('src') || '')
      if (match && dpoImages.includes(match[1].toLowerCase())) {
        img.dataset.dpImg = 'swapped'
        img.src = `${assetBase}dp-opt-${match[1].toLowerCase()}.svg`
        return
      }
      img.dataset.dpImg = 'checked'
      const hide = () => { if (!img.naturalWidth) img.style.display = 'none' }
      if (img.complete) hide(); else img.addEventListener('error', hide, { once: true })
    })
  }

  // Calculator products have a £0.00 base price until a size is entered; show a prompt
  // instead of £0.00 (the calculated price shows as soon as there is one).
  function priceHint() {
    if (!document.querySelector('.dpo-container')) return
    document.querySelectorAll('block-price.product__price').forEach(price => {
      let hint = price.nextElementSibling?.matches?.('[data-dp-price-hint]') ? price.nextElementSibling : null
      if (!hint) {
        hint = document.createElement('span')
        hint.dataset.dpPriceHint = ''
        hint.className = 'dp-price-hint'
        hint.textContent = 'Enter your size to see the price'
        hint.hidden = true
        price.after(hint)
      }
      const zero = Number(price.textContent.replace(/[^0-9]/g, '') || 0) === 0
      price.style.display = zero ? 'none' : ''
      hint.hidden = !zero
    })
  }

  function productLines(variant) {
    document.querySelectorAll('[data-dp-product-line]').forEach(line => {
      const labels = copy(line)
      const isLetterbox = ids(line).includes(String(variant?.id || line.dataset.variantId))
      const threshold = isLetterbox ? Number(line.dataset.letterboxFreeFrom) : Number(line.dataset.freeFrom)
      const rate = isLetterbox ? Number(line.dataset.letterboxRate) : Number(line.dataset.rate1)
      line.querySelector('[data-dp-product-text]').textContent = text(labels.product, threshold).replace('[rate]', money(rate))
    })
  }

  window.dpDeliveryRender = render
  window.dpDeliveryRefresh = refresh
  for (const event of ['cart:updated', 'ajaxProduct:added', 'cart:change', 'cart:open', 'cart:build']) document.addEventListener(event, refresh, true)
  document.addEventListener('variant:change', event => productLines(event.detail?.variant), true)
  document.addEventListener('shopify:section:load', () => { productLines(); refresh() })
  window.addEventListener('pageshow', refresh)

  const originalFetch = window.fetch
  const cartWrite = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/
  window.fetch = function(input) {
    const url = typeof input === 'string' ? input : input?.url || ''
    const result = originalFetch.apply(this, arguments)
    if (cartWrite.test(url)) result.then(response => { response.clone().json().then(noteWrite, () => {}); refresh() }, refresh)
    return result
  }
  const originalOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function(method, url) {
    if (cartWrite.test(url || '')) this.addEventListener('loadend', () => { try { noteWrite(JSON.parse(this.responseText)) } catch {} refresh() }, { once: true })
    return originalOpen.apply(this, arguments)
  }

  let paintTimer
  new MutationObserver(changes => {
    const relevant = changes.some(change => {
      const target = change.target.nodeType === Node.ELEMENT_NODE ? change.target : change.target.parentElement
      if (target?.closest('[data-subtotal], .hulkapps-cart-total, [data-hulkapps-ci-price], .cart__image')) return true
      return [...change.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches('.hulkapps-cart-total') || node.querySelector('.hulkapps-cart-total')))
    })
    if (!relevant || !cart) return
    clearTimeout(paintTimer)
    paintTimer = setTimeout(() => render(cart), 30)
  }).observe(document.body, { childList: true, characterData: true, subtree: true })

  let orderTimer
  const queueOrder = () => { clearTimeout(orderTimer); orderTimer = setTimeout(() => { orderLines(); priceHint() }, 150) }
  document.addEventListener('input', queueOrder, true)
  document.addEventListener('change', queueOrder, true)
  document.querySelectorAll('block-price.product__price').forEach(element => new MutationObserver(queueOrder).observe(element, { childList: true, characterData: true, subtree: true }))

  new MutationObserver(changes => {
    for (const change of changes) for (const node of change.addedNodes) if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.matches('img')) fixCalculatorImages(node.parentElement || document)
      else if (node.querySelector('img')) fixCalculatorImages(node)
    }
  }).observe(document.body, { childList: true, subtree: true })
  fixCalculatorImages()
  priceHint()

  productLines()
  refresh()
})()
